module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns gl-list"
  }, _vm._l((_vm.products), function(item) {
    return _c('div', {
      staticClass: "column is-4"
    }, [_c('product-item', {
      attrs: {
        "product": item
      }
    })], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc7207c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./dev-packages/Shop/assets/site/widgets/product-list/Widget.vue
// module id = 651
// module chunks = 2